import { useEffect } from "react";
import Hero from "./components/Hero";
import CategoriesSection from "./components/CategoriesSection";
import HotRanking from "./components/HotRanking";
import Masterpieces from "./components/Masterpieces";
import ReviewList from "./components/ReviewList";
import BeginnerTeaser from "./components/BeginnerTeaser";
import FaqSection from "./components/FaqSection";
import AboutSection from "./components/AboutSection";
import { games } from "@/mocks/games";
import { faqs } from "@/mocks/faqs";

function useJsonLd() {
  useEffect(() => {
    const data = [
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: "幻夜志",
        url: "https://bpxfn.cn/",
        description: "工口游戏推荐、排行榜、评测与神作盘点。",
      },
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "幻夜志",
        description: "专注成人游戏的推荐、评测与排行榜内容站。",
        email: "hello@huanyezhi.example.com",
      },
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqs.map((f) => ({
          "@type": "Question",
          name: f.q,
          acceptedAnswer: { "@type": "Answer", text: f.a },
        })),
      },
      {
        "@context": "https://schema.org",
        "@type": "ItemList",
        name: "幻夜志口碑游戏推荐",
        itemListElement: games.map((g, i) => ({
          "@type": "ListItem",
          position: i + 1,
          name: g.title,
          url: `https://bpxfn.cn/review/${g.id}`,
        })),
      },
    ];
    const tags = data.map((d) => {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.text = JSON.stringify(d);
      return s;
    });
    tags.forEach((s) => document.head.appendChild(s));
    return () => tags.forEach((s) => s.remove());
  }, []);
}

export default function Home() {
  useJsonLd();
  useEffect(() => {
    document.title = "幻夜志 | 工口游戏推荐与排行榜、评测、入门指南";
  }, []);

  return (
    <>
      <Hero />
      <CategoriesSection />
      <HotRanking />
      <Masterpieces />
      <ReviewList />
      <BeginnerTeaser />
      <FaqSection />
      <AboutSection />
    </>
  );
}